import { render, staticRenderFns } from "./GLTaxAccounts.vue?vue&type=template&id=72d3a42d&scoped=true&"
import script from "./GLTaxAccounts.vue?vue&type=script&lang=js&"
export * from "./GLTaxAccounts.vue?vue&type=script&lang=js&"
import style0 from "./GLTaxAccounts.vue?vue&type=style&index=0&id=72d3a42d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d3a42d",
  null
  
)

export default component.exports